<template xmlns:http="http://www.w3.org/1999/xhtml">
    <div>
        <calcute-frame></calcute-frame>
    </div>
</template>

<script>
    import CalcuteFrame from "./calcuteFrame";
    export default {
        name: "home",
        components: {CalcuteFrame},
    }
</script>

<style scoped>

</style>